const colors = {
  brand: {
    100: "#E9F2FF",
    200: "#C1DBFF",
    300: "#9AC5FF",
    400: "#72AEFF",
    500: "#4B97FF",
    600: "#227DF7",
    700: "#0B5ECE",
    800: "#0046A5",
    900: "#00357D",
    1000: "#000342",
  },
  secondary: {
    200: "#FFD6D0",
    400: "#FF998A",
    500: "#D45454",
    600: "#E83D3D",
    800: "#35DC86",
  },
  white: "#FFFFFF",
};

export default colors;
